import { render } from "./ModalNews.vue?vue&type=template&id=6840a6d0&scoped=true"
import script from "./ModalNews.vue?vue&type=script&lang=js"
export * from "./ModalNews.vue?vue&type=script&lang=js"

import "./ModalNews.vue?vue&type=style&index=0&id=6840a6d0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6840a6d0"]])

export default __exports__